<template>
  <div class="clearfix">
      <vForm class="clearfix" ref="dataForm" v-model="formData" labelWidth="100">
            <vFormItem class="width-85per" :label="$t('fbb.headlogistics.designated_person', { defaultValue: '负责人' })" prop="name" :rules="required">
                <vInput v-model="formData.name"></vInput>
            </vFormItem>
      </vForm>
      <div class="pull-right">
          <vButton class="margin-10" theme="primary" @click="confirm">{{$t('global.common.confirm', { defaultValue: '确定' })}}</vButton>
          <vButton class="margin-10" @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: '取消' })}}</vButton>
      </div>
  </div>
</template>

<script>
import { HttpSetDesignatedPerson } from '@/service/headlogistics'
export default {
    props: ['id'],
    data () {
        return {
            required: [
                {
                    required: true,
                    message: this.$t('global.common.information_empty', { defaultValue: "该信息不能为空,请填写" })
                }
            ],
            formData: {}
        }
    },
    methods: {
       confirm () {
            let flag = true
            this.$refs.dataForm.validate(valid => {
                if (!valid) {
                    flag = false
                }
            })
            if (!flag) return
            HttpSetDesignatedPerson({
                ids: this.id,
                ...this.formData
            }).then(res => {
                this.$VMessage.success(res.message)
                this.$emit('on-close')
                this.$emit('on-update')
            }, err => {
                this.$VMessage.error(err.message)
            })
        },
        cancel () {
            this.$emit('on-close')
        }
    }
}
</script>

<style>

</style>